<div class="cdw-slide-toggle-container" [class.disabled]="disabled">
  <div class="cdw-slide-toggle-wrapper">
    <span *ngIf="label && labelPosition === 'before'" class="toggle-label-text">{{ label }}</span>

    <div class="toggle-wrapper" (click)="toggle(); $event.stopPropagation()" [attr.aria-label]="ariaLabel" role="switch" [attr.aria-checked]="checked">
      <input
        type="checkbox"
        class="toggle-input"
        [checked]="checked"
        [disabled]="disabled"
        tabindex="0"
        (keydown.space)="$event.preventDefault(); toggle()"
        (keydown.enter)="$event.preventDefault(); toggle()"
      />
      <div
        class="toggle-track"
        [class.checked]="checked"
        [style.background-color]="trackColor">
        <div
          class="toggle-thumb"
          [class.checked]="checked"
          [style.background-color]="checked ? thumbColor : thumbUncheckedColor">
          <!-- Checkmark icon when checked -->
          <svg *ngIf="showCheckmark && checked" class="checkmark-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [style.color]="checkmarkColor">
            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <!-- Minus icon when unchecked -->
          <svg *ngIf="showCheckmark && !checked" class="minus-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [style.color]="minusIconColor">
            <path d="M5 12H19" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>

    <span *ngIf="label && labelPosition === 'after'" class="toggle-label-text">{{ label }}</span>
  </div>
</div>
